import { ActionTypes } from '@/types';

// Export enum values as constants for backward compatibility
export const SET_GENERATION_CONFIG = ActionTypes.SET_GENERATION_CONFIG;
export const SET_MODEL_CONFIG = ActionTypes.SET_MODEL_CONFIG;
export const USER_LOGOUT = ActionTypes.USER_LOGOUT;
export const USER_FETCH = ActionTypes.USER_FETCH;
export const SET_AUTH_CONFIG = ActionTypes.SET_AUTH_CONFIG;
export const SET_AUTH_USER = ActionTypes.SET_AUTH_USER;
export const SET_PAGE_TITLE = ActionTypes.SET_PAGE_TITLE;
export const SET_DOC_TYPES = ActionTypes.SET_DOC_TYPES;
export const FORM_SET_ERROR = ActionTypes.FORM_SET_ERROR;
export const FORM_CLEAR_ERROR = ActionTypes.FORM_CLEAR_ERROR;
